var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IMListExport',{attrs:{"title":_vm.title,"listType":_vm.listType,"dialogType":_vm.dialogType,"im":_vm.getIM()}})
}
var staticRenderFns = []

export { render, staticRenderFns }